__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "graphql-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.4.17", () => (Promise.all([__webpack_require__.e("vendors-node_modules_apollo_client_cache_inmemory_inMemoryCache_js-node_modules_apollo_client-f3658f"), __webpack_require__.e("vendors-node_modules_apollo_client_link_core_ApolloLink_js-node_modules_apollo_client_utiliti-4daba4"), __webpack_require__.e("vendors-node_modules_apollo_client_index_js"), __webpack_require__.e("webpack_sharing_consume_default_graphql_graphql"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__("../../node_modules/@apollo/client/index.js"))))));
			register("@apollo/persisted-query-lists", "^1.0.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_apollo_client_cache_inmemory_inMemoryCache_js-node_modules_apollo_client-f3658f"), __webpack_require__.e("vendors-node_modules_apollo_client_link_core_ApolloLink_js-node_modules_apollo_client_utiliti-4daba4"), __webpack_require__.e("webpack_sharing_consume_default_graphql_graphql"), __webpack_require__.e("node_modules_apollo_persisted-query-lists_dist_index_js")]).then(() => (() => (__webpack_require__("../../node_modules/@apollo/persisted-query-lists/dist/index.js"))))));
			register("apollo-upload-client", "^17.0.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_apollo_client_cache_inmemory_inMemoryCache_js-node_modules_apollo_client-f3658f"), __webpack_require__.e("vendors-node_modules_apollo_client_link_core_ApolloLink_js-node_modules_apollo_client_utiliti-4daba4"), __webpack_require__.e("vendors-node_modules_apollo-upload-client_public_index_mjs"), __webpack_require__.e("webpack_sharing_consume_default_graphql_graphql")]).then(() => (() => (__webpack_require__("../../node_modules/apollo-upload-client/public/index.mjs"))))));
			register("graphql", "15.8.0", () => (__webpack_require__.e("vendors-node_modules_graphql_index_mjs").then(() => (() => (__webpack_require__("../../node_modules/graphql/index.mjs"))))));
			register("react", "17.0.2", () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__("../../node_modules/react/index.js"))))));
			initExternal("webpack/container/reference/@do/current-context-urn");
			initExternal("webpack/container/reference/@do/message-bus");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};